import { useEffect, useState } from 'react'
import useStore from '@/hooks/useStore'
import { get, pick } from 'lodash'

const useGetValuesForm = ({ id = 2 }) => {
  const { getItems, singleById } = useStore()
  const [dataForm, setDataForm] = useState(null)
  const [formValuesLoading, setformValuesLoading] = useState(true)

  useEffect(() => {
    const getDataForm = async () => {
      await getItems({ type: 'forms' })
      setformValuesLoading(false)
      setDataForm(singleById({ type: 'forms', id }))
    }
    getDataForm()
  }, [])

  return {
    formValuesLoading,
    dataForm: {
      fields: get(dataForm, ['fields'], []),
      data: pick(get(dataForm, ['data'], {}), ['id', 'submitURL', 'title']),
    },
  }
}

export default useGetValuesForm
